<ion-header>
  <ion-toolbar>
    <ion-title class="ion-text-center"> {{ edit ? 'Edit' : 'Add Network' }} Printer </ion-title>

    <ion-buttons class="header-buttons" slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form *ngIf="parentFormGroup" [formSubmittable]="save" class="printer-form-group" [formGroup]="parentFormGroup">
    <h4>Printer Name</h4>
    <ion-item class="password-input">
      <ion-input type="text" formControlName="name" autofocus="true" clearInput="true" placeholder="My Printer">
      </ion-input>
    </ion-item>

    <ion-row class="ion-justify-content-between">
      <h4 class="ion-float-left">Address</h4>
    </ion-row>

    <ion-item [disabled]="edit && printer && printer.Type === 'bluetooth'" class="password-input">
      <ion-input type="text" formControlName="address" clearInput="true" placeholder="192.168.0.1"></ion-input>
    </ion-item>

    <!-- ETHERNET PRINTER SPECIFIC ROWS -->
    <ng-container *ngIf="!edit || (printer && printer.Type === 'ethernet')">
      <ion-row class="printerInfo">
        <ion-icon slot="icon-only" name="information-circle-outline"></ion-icon>
        <ion-select placeholder="Where do I find the Address?" (ionChange)="printerSelectedChange($event)">
          <ion-select-option value="epson-receipt">Epson Receipt Printers</ion-select-option>
          <ion-select-option value="senor">Senor</ion-select-option>
          <ion-select-option value="bixolon">Bixolon</ion-select-option>
        </ion-select>

        <div *ngIf="printerInstruction" class="printer-instructions" [innerHTML]="printerInstruction"></div>
      </ion-row>

      <h4>Port</h4>
      <ion-item class="password-input">
        <ion-input type="text" formControlName="port" clearInput="true"></ion-input>
      </ion-item>
    </ng-container>

    <ion-list lines="full">
      <ion-item class="no-background setup-element">
        <ion-label class="item-preference-label"> Printer is Active </ion-label>
        <ion-toggle
          class="active-toggle"
          mode="ios"
          [formControl]="activatePrinter"
          [checked]="activatePrinter.value"
          slot="end"
        ></ion-toggle>
      </ion-item>

      <ion-item class="no-background print-repeat-item setup-element">
        <ion-label class="item-preference-label"> Print dockets multiple times </ion-label>

        <div class="component" slot="end">
          <ion-button fill="clear" (click)="minusPrintDocket()" [disabled]="printRepeat.value === 1">
            <ion-icon name="remove-outline"></ion-icon>
          </ion-button>
          <div class="label">{{ printRepeat.value }}</div>
          <ion-button fill="clear" (click)="addPrintDocket()" [disabled]="printRepeat.value === 4">
            <ion-icon name="add-outline"></ion-icon>
          </ion-button>
        </div>
      </ion-item>
    </ion-list>

    <br />
    <br />
  </form>

  <div class="printer-groups-config">
    <ng-container *ngIf="printerGroups && printerGroups.length > 0">
      <ion-list lines="full">
        <ion-list-header>
          <h2>Printer Groups</h2>
        </ion-list-header>

        <ion-item *ngFor="let group of printerGroupForm" class="no-background setup-element">
          <ion-label class="item-preference-label">{{ group.group.Name }}</ion-label>
          <ion-toggle
            class="printer-group-toggle"
            mode="ios"
            [(ngModel)]="group.isChecked"
            slot="end"
            (ionChange)="vetoPassPrinter($event.detail.checked)"
          ></ion-toggle>
        </ion-item>
      </ion-list>

      <br />
      <p class="divider-text"><strong>or </strong> set this printer to print the entire Order</p>
      <br />
    </ng-container>

    <ion-list lines="full">
      <ion-list-header *ngIf="!printerGroups || printerGroups.length === 0">
        <h2>Printer Groups</h2>
      </ion-list-header>

      <ion-item class="item-preference no-background full-order-docket setup-element">
        <ion-label class="item-preference-label"> Full Order Docket: </ion-label>

        <ion-toggle
          class="full-docket-toggle"
          mode="ios"
          [formControl]="passPrinter"
          [checked]="passPrinter.value"
          slot="end"
          (ionChange)="vetoPrinterGroupSelection($event.detail.checked)"
        ></ion-toggle>
      </ion-item>
    </ion-list>
  </div>
</ion-content>

<ion-footer class="ion-text-center hub-btn-container">
  <ion-button class="hub-btn" fill="clear" (click)="close()"> Cancel </ion-button>
  <ion-button
    type="submit"
    #saveBtn
    class="hub-btn"
    [disabled]="!parentFormGroup || parentFormGroup.invalid"
    (click)="save()"
  >
    Save
  </ion-button>
</ion-footer>
